module.exports = __webpack_public_path__ + "img/hyzw.0cfec8d9.jpg";